import {
  type ISavedEmailSection,
  savedEmailSectionSchema,
} from "@redotech/redo-model/saved-email-section";
import * as z from "zod/v4";

export const getSavedEmailSections = {
  name: "getSavedEmailSections" as const,
  input: z.object({}),
  output: z.array(savedEmailSectionSchema as ISavedEmailSection),
};
